import React from "react";
import "./SocialNetworksStyle.sass"
const SocialNetworks = ({network, adres}) => {
    return (
        <div className="profile__list-about-profile profile__network">
            <div className='main-text'><img src={require("../../../../img/profileImg/" + network + ".png")} alt=""/>{network}:</div>
            <div className="additional-text"><p>{adres ? adres : "Отсутствует"}</p></div>
        </div>
    )
};

export default SocialNetworks